// 导出所有核心模块
export * from "./Actions.js";                    // 导出动作相关功能
export * from "./AnimationPath.js";              // 导出动画路径相关功能
export * from "./Annotation.js";                 // 导出注释标记相关功能
export * from "./defines.js";                    // 导出常量和枚举定义
export * from "./Enum.js";                       // 导出枚举类型
export * from "./EventDispatcher.js";            // 导出事件调度器
export * from "./Features.js";                   // 导出功能特性管理
export * from "./KeyCodes.js";                   // 导出键盘按键代码定义
export * from "./LRU.js";                        // 导出最近最少使用缓存实现
export * from "./PointCloudEptGeometry.js";      // 导出EPT格式点云几何体
export * from "./PointCloudOctree.js";           // 导出点云八叉树
export * from "./PointCloudOctreeGeometry.js";   // 导出点云八叉树几何体
export * from "./PointCloudTree.js";             // 导出点云树结构
export * from "./Points.js";                     // 导出点相关功能
export * from "./Potree_update_visibility.js";   // 导出点云可见性更新功能
export * from "./PotreeRenderer.js";             // 导出Potree渲染器
export * from "./ProfileRequest.js";             // 导出剖面请求功能
export * from "./TextSprite.js";                 // 导出文本精灵
export * from "./utils.js";                      // 导出工具函数
export * from "./Version.js";                    // 导出版本信息
export * from "./WorkerPool.js";                 // 导出工作线程池
export * from "./XHRFactory.js";                 // 导出XHR工厂(用于处理HTTP请求)
export * from "./viewer/SaveProject.js";         // 导出项目保存功能
export * from "./viewer/LoadProject.js";         // 导出项目加载功能
export * from "./viewer/LoadClassification.js";         // 导出点云分类加载功能

// 导出材质相关模块
export * from "./materials/ClassificationScheme.js";     // 导出点云分类方案
export * from "./materials/EyeDomeLightingMaterial.js";  // 导出眼部穹顶光照材质
export * from "./materials/Gradients.js";                // 导出渐变色功能
export * from "./materials/NormalizationEDLMaterial.js"; // 导出EDL标准化材质
export * from "./materials/NormalizationMaterial.js";    // 导出标准化材质
export * from "./materials/PointCloudMaterial.js";       // 导出点云材质

// 导出加载器相关模块
export * from "./loader/POCLoader.js";              // 导出POC格式加载器
export * from "./modules/loader/2.0/OctreeLoader.js"; // 导出八叉树加载器2.0版本
export * from "./loader/EptLoader.js";              // 导出EPT格式加载器
export * from "./loader/ept/BinaryLoader.js";       // 导出EPT二进制加载器
export * from "./loader/ept/LaszipLoader.js";       // 导出EPT Laszip格式加载器
export * from "./loader/ept/ZstandardLoader.js";    // 导出EPT Zstandard压缩格式加载器
export * from "./loader/PointAttributes.js";        // 导出点属性功能
export * from "./loader/ShapefileLoader.js";        // 导出Shapefile格式加载器
export * from "./loader/GeoPackageLoader.js";       // 导出GeoPackage格式加载器

// 导出工具相关模块
export * from "./utils/Box3Helper.js";              // 导出3D边界盒辅助工具
export * from "./utils/ClippingTool.js";            // 导出裁剪工具
export * from "./utils/ClipVolume.js";              // 导出裁剪体积
export * from "./utils/GeoTIFF.js";                 // 导出GeoTIFF工具
export * from "./utils/Measure.js";                 // 导出测量工具
export * from "./utils/MeasuringTool.js";           // 导出测量工具组件
export * from "./utils/Message.js";                 // 导出消息功能
export * from "./utils/PointCloudSM.js";            // 导出点云阴影映射
export * from "./utils/PolygonClipVolume.js";       // 导出多边形裁剪体积
export * from "./utils/Profile.js";                 // 导出剖面功能
export * from "./utils/ProfileTool.js";             // 导出剖面工具
export * from "./utils/ScreenBoxSelectTool.js";     // 导出屏幕框选工具
export * from "./utils/SpotLightHelper.js";         // 导出聚光灯辅助工具
export * from "./utils/TransformationTool.js";      // 导出变换工具
export * from "./utils/Volume.js";                  // 导出体积功能
export * from "./utils/VolumeTool.js";              // 导出体积工具
export * from "./utils/Compass.js";                 // 导出指南针功能

// 导出查看器相关模块
export * from "./viewer/viewer.js";                 // 导出查看器主组件
export * from "./viewer/Scene.js";                  // 导出场景组件
export * from "./viewer/HierarchicalSlider.js";     // 导出分层滑块控件

// 导出额外模块
export * from "./modules/OrientedImages/OrientedImages.js";   // 导出定向图像功能
export * from "./modules/Images360/Images360.js";             // 导出360度全景图像功能
export * from "./modules/CameraAnimation/CameraAnimation.js"; // 导出相机动画功能

// 重复导出八叉树加载器2.0版本(可能是为了向后兼容)
export * from "./modules/loader/2.0/OctreeLoader.js";

// 导出导航控制器
export {OrbitControls} from "./navigation/OrbitControls.js";                   // 导出轨道控制器
export {FirstPersonControls} from "./navigation/FirstPersonControls.js";       // 导出第一人称控制器
export {EarthControls} from "./navigation/EarthControls.js";                   // 导出地球控制器
export {DeviceOrientationControls} from "./navigation/DeviceOrientationControls.js"; // 导出设备方向控制器
export {VRControls} from "./navigation/VRControls.js";                         // 导出VR控制器

// 导入Three.js扩展
import "./extensions/OrthographicCamera.js";    // 导入正交相机扩展
import "./extensions/PerspectiveCamera.js";     // 导入透视相机扩展
import "./extensions/Ray.js";                   // 导入射线扩展

// 导入核心组件
import {LRU} from "./LRU.js";                   // 导入LRU缓存
import {OctreeLoader} from "./modules/loader/2.0/OctreeLoader.js"; // 导入八叉树加载器
import {POCLoader} from "./loader/POCLoader.js"; // 导入POC格式加载器
import {CopcLoader, EptLoader} from "./loader/EptLoader.js"; // 导入COPC和EPT格式加载器
import {PointCloudOctree} from "./PointCloudOctree.js"; // 导入点云八叉树
import {WorkerPool} from "./WorkerPool.js";     // 导入工作线程池

// 创建全局工作线程池
export const workerPool = new WorkerPool();

// 定义版本信息
export const version = {
	major: 1,
	minor: 8,
	suffix: '.0'
};

// 创建全局LRU缓存
export let lru = new LRU();

// 输出当前Potree版本信息
// console.log('Potree ' + version.major + '.' + version.minor + version.suffix);

// 全局配置变量
export let pointBudget = 100 * 1000 * 1000;    // 点预算数量(每次渲染最多显示的点数)
export let framenumber = 0;                  // 帧计数器
export let numNodesLoading = 0;              // 当前正在加载的节点数量
export let maxNodesLoading = 4;              // 最大同时加载节点数量

// 调试对象
export const debug = {};

// 脚本和资源路径设置
let scriptPath = "";

// 尝试确定脚本路径
if (document.currentScript && document.currentScript.src) {
	scriptPath = new URL(document.currentScript.src + '/..').href;
	if (scriptPath.slice(-1) === '/') {
		scriptPath = scriptPath.slice(0, -1);
	}
} else if(import.meta){
	scriptPath = new URL(import.meta.url + "/..").href;
	if (scriptPath.slice(-1) === '/') {
		scriptPath = scriptPath.slice(0, -1);
	}
}else {
	console.error('Potree无法使用document.currentScript找到脚本路径。Potree是否通过script标签引入？您的浏览器是否支持此功能？');
}

// 设置资源路径
let resourcePath = scriptPath + '/resources';

// 导出脚本路径和资源路径
// scriptPath: build/potree
// resourcePath:build/potree/resources
export {scriptPath, resourcePath};


/**
 * 加载点云数据
 * @param {string} path - 点云数据路径
 * @param {string} name - 点云名称
 * @param {function} callback - 加载完成后的回调函数
 * @returns {Promise} - 如果未提供回调函数，则返回Promise
 */
export function loadPointCloud(path, name, callback){
	let loaded = function(e){
		e.pointcloud.name = name;
		callback(e);
	};

	let promise = new Promise( resolve => {

		// 根据文件路径选择合适的加载器加载点云
		if (!path){
			// 没有路径参数，不执行任何操作
		} else if (path.includes('ept.json')) {
			// 加载EPT格式点云数据
			EptLoader.load(path, function(geometry) {
				if (!geometry) {
					console.error(new Error(`加载点云失败，URL: ${path}`));
				}
				else {
					let pointcloud = new PointCloudOctree(geometry);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.includes('.copc.laz')) {
			// 加载COPC格式点云数据
			CopcLoader.load(path, function(geometry) {
				if (!geometry) {
					console.error(new Error(`加载点云失败，URL: ${path}`));
				}
				else {
					let pointcloud = new PointCloudOctree(geometry);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.indexOf('cloud.js') > 0) {
			// 加载Potree原生格式点云数据
			POCLoader.load(path, function (geometry) {
				if (!geometry) {
					//callback({type: 'loading_failed'});
					console.error(new Error(`加载点云失败，URL: ${path}`));
				} else {
					let pointcloud = new PointCloudOctree(geometry);
					// loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.indexOf('metadata.json') > 0) {
			// 加载新格式(2.0)的点云数据
			Potree.OctreeLoader.load(path).then(e => {
				let geometry = e.geometry;

				if(!geometry){
					console.error(new Error(`加载点云失败，URL: ${path}`));
				}else{
					let pointcloud = new PointCloudOctree(geometry);

					let aPosition = pointcloud.getAttribute("position");

					let material = pointcloud.material;
					material.elevationRange = [
						aPosition.range[0][2],
						aPosition.range[1][2],
					];

					// loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});

			// 也尝试使用八叉树加载器加载
			OctreeLoader.load(path, function (geometry) {
				if (!geometry) {
					//callback({type: 'loading_failed'});
					console.error(new Error(`加载点云失败，URL: ${path}`));
				} else {
					let pointcloud = new PointCloudOctree(geometry);
					// loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.indexOf('.vpc') > 0) {
			// 加载Arena4D格式点云数据
			PointCloudArena4DGeometry.load(path, function (geometry) {
				if (!geometry) {
					//callback({type: 'loading_failed'});
					console.error(new Error(`加载点云失败，URL: ${path}`));
				} else {
					let pointcloud = new PointCloudArena4D(geometry);
					// loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else {
			//callback({'type': 'loading_failed'});
			console.error(new Error(`加载点云失败，URL: ${path}`));
		}
	});

	// 处理回调或返回Promise
	if(callback){
		promise.then(pointcloud => {
			loaded(pointcloud);
		});
	}else{
		return promise;
	}
};


// 添加selectgroup jQuery插件
// 这个插件用于创建一组单选按钮，样式类似于按钮组
(function($){
	$.fn.extend({
		selectgroup: function(args = {}){

			let elGroup = $(this);
			let rootID = elGroup.prop("id");
			let groupID = `${rootID}`;
			let groupTitle = (args.title !== undefined) ? args.title : "";

			let elButtons = [];
			elGroup.find("option").each((index, value) => {
				let buttonID = $(value).prop("id");
				let label = $(value).html();
				let optionValue = $(value).prop("value");

				let elButton = $(`
					<span style="flex-grow: 1; display: inherit">
					<label for="${buttonID}" class="ui-button" style="width: 100%; padding: .4em .1em">${label}</label>
					<input type="radio" name="${groupID}" id="${buttonID}" value="${optionValue}" style="display: none"/>
					</span>
				`);
				let elLabel = elButton.find("label");
				let elInput = elButton.find("input");

				elInput.change( () => {
					elGroup.find("label").removeClass("ui-state-active");
					elGroup.find("label").addClass("ui-state-default");
					if(elInput.is(":checked")){
						elLabel.addClass("ui-state-active");
					}else{
						//elLabel.addClass("ui-state-default");
					}
				});

				elButtons.push(elButton);
			});

			let elFieldset = $(`
				<fieldset style="border: none; margin: 0px; padding: 0px">
					<legend>${groupTitle}</legend>
					<span style="display: flex">

					</span>
				</fieldset>
			`);

			let elButtonContainer = elFieldset.find("span");
			for(let elButton of elButtons){
				elButtonContainer.append(elButton);
			}

			// 设置按钮组样式
			elButtonContainer.find("label").each( (index, value) => {
				$(value).css("margin", "0px");
				$(value).css("border-radius", "0px");
				$(value).css("border", "1px solid black");
				$(value).css("border-left", "none");
			});
			elButtonContainer.find("label:first").each( (index, value) => {
				$(value).css("border-radius", "4px 0px 0px 4px");

			});
			elButtonContainer.find("label:last").each( (index, value) => {
				$(value).css("border-radius", "0px 4px 4px 0px");
				$(value).css("border-left", "none");
			});

			// 替换原始元素
			elGroup.empty();
			elGroup.append(elFieldset);
		}
	});
})(jQuery);
